var _defs, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeuroMuseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "30 65 310 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #010101;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.08,70.53v64.97H38.12v-64.97h64.96ZM100.31,73.31h-59.41v59.42h59.41v-59.42Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 92.26,
    y: 76.08,
    width: 5.55,
    height: 54.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.68,
    y: 76.08,
    width: 5.27,
    height: 54.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.83,
    y: 86.91,
    width: 5.55,
    height: 32.49
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.78,
    y: 81.36,
    width: 5.27,
    height: 29.99
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.15,
    y: 94.96,
    width: 5.27,
    height: 29.71
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.21,
    y: 100.24,
    width: 5.27,
    height: 27.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.73,
    y: 78.86,
    width: 5.27,
    height: 26.93
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125,117.96h-6.19v-27.6h5.26l11.06,16.4h.26v-16.4h6.19v27.6h-5.22l-11.1-16.56h-.26v16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.99,118.37c-2.04,0-3.83-.38-5.37-1.14-1.54-.76-2.74-1.9-3.6-3.42-.86-1.52-1.28-3.39-1.28-5.63v-2.06c0-2.25.45-4.13,1.34-5.63.9-1.5,2.1-2.63,3.61-3.38s3.18-1.12,5.02-1.12c1.95,0,3.67.4,5.16,1.21,1.48.81,2.64,1.97,3.48,3.49.83,1.52,1.25,3.33,1.25,5.43v2.39h-13.59v.99c0,1.24.37,2.23,1.12,2.98.75.75,1.69,1.12,2.84,1.12.65,0,1.23-.1,1.75-.29.52-.2.94-.47,1.26-.82s.51-.75.57-1.19h5.9c-.04.73-.25,1.5-.62,2.33-.37.82-.93,1.59-1.69,2.32s-1.72,1.31-2.9,1.76-2.6.68-4.26.68ZM153.01,104.88h7.42v-.14c0-.82-.15-1.54-.46-2.16-.3-.62-.73-1.11-1.28-1.46s-1.2-.53-1.94-.53-1.39.18-1.95.53-1,.84-1.31,1.46-.48,1.34-.48,2.16v.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.26,96.36v21.6h-6.25v-3.62h-.32c-.19.57-.54,1.15-1.05,1.76-.51.61-1.2,1.12-2.06,1.55-.86.42-1.93.64-3.19.64-1.43,0-2.68-.27-3.75-.8-1.07-.53-1.9-1.35-2.5-2.47-.59-1.11-.89-2.53-.89-4.26v-14.4h6.45v12.74c0,1.04.17,1.84.5,2.4.34.56.77.94,1.28,1.15.52.21,1.05.31,1.59.31.67,0,1.29-.16,1.86-.48.57-.32,1.02-.78,1.38-1.38.35-.61.53-1.33.53-2.18v-12.56h6.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.15,117.96v-21.6h6.45v3.42h.3c.13-.5.4-1.03.81-1.61.4-.57.96-1.07,1.68-1.49.71-.42,1.59-.63,2.63-.63.46,0,.84.01,1.15.04.31.03.57.07.79.14v5.48c-.23-.08-.56-.14-.99-.19-.43-.05-.89-.07-1.38-.07-1.11,0-2.02.2-2.73.6s-1.24.96-1.58,1.68-.51,1.56-.51,2.52v11.71h-6.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.86,95.98c2.09,0,3.9.41,5.43,1.24s2.71,2.01,3.55,3.54c.84,1.53,1.25,3.32,1.25,5.37v1.9c0,2.2-.42,4.07-1.25,5.61-.84,1.54-2.02,2.72-3.55,3.52s-3.34,1.2-5.43,1.2-3.92-.4-5.46-1.2c-1.54-.8-2.72-1.97-3.55-3.51-.83-1.54-1.24-3.4-1.24-5.6v-1.88c0-2.02.42-3.8,1.25-5.33s2.02-2.72,3.56-3.58c1.54-.86,3.35-1.28,5.44-1.28ZM223.86,100.79c-.89,0-1.61.25-2.15.76-.55.51-.95,1.17-1.2,1.98-.26.82-.38,1.69-.38,2.62v2c0,.9.12,1.77.36,2.59.24.82.64,1.49,1.18,2.01s1.28.78,2.19.78,1.65-.26,2.18-.78.93-1.19,1.16-2c.24-.82.35-1.68.35-2.6v-2c0-.94-.12-1.82-.37-2.64-.25-.82-.64-1.47-1.18-1.97-.54-.5-1.25-.75-2.14-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.18,117.96h-5.9v-27.6h6.86l7.1,15.73h.22l7.1-15.73h6.81v27.6h-5.99v-17.21h-.32l-5.8,13.06h-3.9l-5.86-13.06h-.3v17.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.37,96.36v21.6h-6.25v-3.62h-.32c-.19.57-.54,1.15-1.05,1.76-.51.61-1.2,1.12-2.06,1.55-.86.42-1.93.64-3.2.64-1.43,0-2.68-.27-3.75-.8-1.07-.53-1.9-1.35-2.5-2.47-.59-1.11-.89-2.53-.89-4.26v-14.4h6.45v12.74c0,1.04.17,1.84.5,2.4.34.56.77.94,1.28,1.15.52.21,1.05.31,1.59.31.67,0,1.29-.16,1.86-.48.57-.32,1.02-.78,1.38-1.38.35-.61.53-1.33.53-2.18v-12.56h6.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.42,102.86c0-1.66.42-2.99,1.26-3.99.84-1,1.95-1.74,3.34-2.19s2.88-.69,4.48-.69,3.13.24,4.43.73,2.31,1.21,3.04,2.17c.73.96,1.1,2.16,1.1,3.59h-5.62c-.04-.39-.18-.76-.41-1.1-.24-.34-.57-.63-1-.85-.43-.22-.98-.33-1.64-.33-.93,0-1.64.2-2.14.61-.5.4-.75.93-.75,1.58,0,.5.19.9.57,1.2.38.3.86.55,1.45.73.59.18,1.21.32,1.87.42.66.1,1.27.19,1.84.27,1.32.22,2.47.56,3.46,1.04.98.48,1.75,1.13,2.3,1.95.55.82.82,1.87.82,3.15,0,1.5-.38,2.78-1.13,3.86-.76,1.08-1.85,1.91-3.29,2.49-1.44.58-3.19.87-5.25.87s-3.65-.28-5.01-.84c-1.36-.56-2.4-1.33-3.1-2.32s-1.06-2.12-1.06-3.4h6.25c.05.44.21.84.46,1.19.26.35.62.62,1.08.82.46.2,1.03.29,1.69.29.74,0,1.34-.1,1.8-.29.46-.2.79-.47,1.01-.81s.32-.72.32-1.12c0-.62-.26-1.08-.77-1.39-.51-.3-1.17-.53-1.98-.69-.81-.15-1.67-.32-2.57-.5-1.25-.24-2.4-.6-3.44-1.07-1.04-.47-1.86-1.14-2.48-2-.61-.86-.92-2-.92-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.8,118.37c-2.04,0-3.83-.38-5.37-1.14-1.54-.76-2.74-1.9-3.6-3.42-.86-1.52-1.28-3.39-1.28-5.63v-2.06c0-2.25.45-4.13,1.34-5.63.9-1.5,2.1-2.63,3.61-3.38s3.18-1.12,5.02-1.12c1.95,0,3.67.4,5.16,1.21,1.48.81,2.64,1.97,3.48,3.49.83,1.52,1.25,3.33,1.25,5.43v2.39h-13.59v.99c0,1.24.37,2.23,1.12,2.98.75.75,1.7,1.12,2.84,1.12.65,0,1.23-.1,1.75-.29.52-.2.94-.47,1.26-.82s.51-.75.57-1.19h5.9c-.04.73-.25,1.5-.62,2.33-.37.82-.93,1.59-1.69,2.32s-1.72,1.31-2.9,1.76-2.6.68-4.26.68ZM326.81,104.88h7.42v-.14c0-.82-.15-1.54-.46-2.16-.3-.62-.73-1.11-1.28-1.46s-1.2-.53-1.94-.53-1.39.18-1.95.53c-.56.35-1,.84-1.31,1.46-.32.62-.48,1.34-.48,2.16v.14Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeuroMuseLogo);
export default __webpack_public_path__ + "static/media/NeuroMuseLogo.d7b6b0971fe28e7c3546a0982aeec2fe.svg";
export { ForwardRef as ReactComponent };